<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path d="M923.8 396c-21.9-25.2-53.4-39.5-86.4-39.5H626.5V228c0-85.8-69.8-155.5-155.5-155.5-13.4 0-25.5 7.9-30.9 20.1L288.7 433.1H199c-62.4 0-117.9 50.1-127 119.5l.3 288.6C80.9 904.5 135 951.5 198 951.5h583c56.5 0 105.2-41.8 113.6-97.7l56-365.2c5.2-33.4-4.6-67.1-26.8-92.6zM274.9 883.9h-76.2c-29.9 0-55.3-22.1-59-47.3l-.3-279.5c4.2-31.3 30.9-56.4 60.2-56.4H275v383.2zm609-405.4-56 365.2c-3.5 23.2-24.3 38.9-47.7 40.2H342.5V478.7l149.3-336.1c38.4 9.4 67.1 44.1 67.1 85.4v162.3c0 18.7 15.1 33.8 33.8 33.8H837c13.7 0 26.7 5.9 35.7 16.2 9.2 10.5 13.2 24.5 11.2 38.2z" fill="#d73e18" />
      <path d="m883.9 478.5-56 365.2c-3.5 23.2-24.3 38.9-47.7 40.2H342.5V478.7l149.3-336.1c38.4 9.4 67.1 44.1 67.1 85.4v162.3c0 18.7 15.1 33.8 33.8 33.8H837c13.7 0 26.7 5.9 35.7 16.2 9.2 10.5 13.2 24.5 11.2 38.2z" fill="#fbd7a2" />
      <path d="M274.9 500.7v383.2h-76.2c-29.9 0-55.3-22.1-59-47.3l-.3-279.5c4.2-31.3 30.9-56.4 60.2-56.4h75.3z" fill="#ee962d" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1.2em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
